import { jsx as _jsx } from "react/jsx-runtime";
export const TabPanel = ({ children }) => {
    return _jsx("div", { children: children });
};
